import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { CustomAudiences, CustomAudiencesVariables } from './__generated__/CustomAudiences';

export const CUSTOM_AUDIENCES_QUERY = gql`
  query CustomAudiences($articleId: ID, $facebookAccountId: ID, $query: String!) {
    customAudiences(articleId: $articleId, facebookAccountId: $facebookAccountId, query: $query)
  }
`;

export const useCustomAudiencesQuery = () => {
  return useLazyQuery<CustomAudiences, CustomAudiencesVariables>(CUSTOM_AUDIENCES_QUERY, { client: kmsClient });
};
